import { DeliveryServices } from '@/domain/models/DeliveryService';
import { Enterprise } from '@/domain/models/Enterprise';
import { FranchiseType, Prefecture } from '@/domain/models/Store';
import { unique, uniqueObjInArray } from '@/lib/util';

export interface SelectOption {
  value: string;
  label: string;
}

export class SelectOption {
  static createSelectOptions = (
    enterprise: Enterprise,
    deliveryServices: DeliveryServices
  ): {
    masterBrandOptions: SelectOption[];
    masterStoreOptions: SelectOption[];
    authStoreOptions: SelectOption[];
    deliveryServiceOptions: SelectOption[];
  } => {
    const masterBrandOptions: SelectOption[] = [];
    const masterStoreOptions: SelectOption[] = [];
    const authStoreOptions: SelectOption[] = [];
    const deliveryServiceOptions: SelectOption[] = [];

    enterprise.brands.forEach((brand) => {
      // ブランド名のオプション作成
      masterBrandOptions.push({
        value: brand.brand_id.toString(),
        label: brand.brand_name,
      });
      brand.stores.forEach((store) => {
        // 店舗名のオプション作成
        masterStoreOptions.push({
          value: store.master_store_id.toString(),
          label: store.store_name,
        });
      });
      brand.stores.forEach((store) => {
        // 拠点名のオプション作成
        authStoreOptions.push({
          value: store.auth_store_id.toString(),
          label: store.auth_store_name,
        });
      });
    });

    deliveryServices.delivery_services.forEach((delivery_service) => {
      // デリバリーサービス名のオプション作成
      deliveryServiceOptions.push({
        value: delivery_service.delivery_service_id.toString(),
        label: delivery_service.delivery_service_name,
      });
    });

    return {
      masterBrandOptions: uniqueObjInArray(masterBrandOptions, 'value'),
      masterStoreOptions: uniqueObjInArray(masterStoreOptions, 'value'),
      authStoreOptions: uniqueObjInArray(authStoreOptions, 'value'),
      deliveryServiceOptions: uniqueObjInArray(deliveryServiceOptions, 'value'),
    };
  };

  static createSelectOptionValues = (
    enterprise: Enterprise
  ): {
    brandValues: string[];
    storeNameValues: string[];
    prefectureValues: Prefecture[];
    cityValues: string[];
  } => {
    const brandValues: string[] = [];
    const storeNameValues: string[] = [];
    const prefectureValues: Prefecture[] = [];
    const cityValues: string[] = [];

    enterprise.brands.forEach((brand) => {
      // ブランド名のオプション作成
      brandValues.push(brand.brand_name);

      brand.stores.forEach((store) => {
        // 店舗名のオプション作成
        storeNameValues.push(store.store_name);

        if (store.prefecture !== '') {
          // 都道府県のオプション作成
          prefectureValues.push(store.prefecture);
        }

        if (store.city !== '') {
          // 市区町村のオプション作成
          cityValues.push(store.city);
        }
      });
    });

    return {
      brandValues: unique(brandValues),
      storeNameValues: unique(storeNameValues),
      prefectureValues: unique(prefectureValues),
      cityValues: unique(cityValues),
    };
  };

  static toFranchiseTypeSelectOptions = (): SelectOption[] => {
    return Object.keys(FranchiseType).map((franchiseType) => {
      return {
        value: franchiseType,
        label: FranchiseType[franchiseType as FranchiseType],
      };
    });
  };
}
